import React, { useEffect } from 'react';
import { Input } from 'reactstrap';

function Checkbox({ item, checked, onToggle }) {
    useEffect(() => {
        if (checked) {
        }
    }, [checked]);

    return (
        <div className="checkbox-cell">
            <label className="checkboxs">
                <Input
                    type="checkbox"
                    checked={!!checked}
                    className="checkbox_animated border border-primary"
                    onChange={() => onToggle(item._id)}
                />
              {'\u00A0\u00A0\u00A0\u00A0'}{item.title}
            </label>
        </div>
    );
}

export default Checkbox;



// import React, { useState, useEffect } from 'react';
// import { Input } from 'reactstrap';

// function Checkbox({ type = 'td', onChecked, item, setItem, disabled = false, defaultChecked = false }) {
//     const [checked, setChecked] = useState(defaultChecked);

//     const change = () => {
//         const newChecked = !checked;
//         setChecked(newChecked);
//         setItem(item);
//         onChecked && onChecked(item._id, newChecked);
//     };

//     return React.createElement(
//         type,
//         { className: 'checkbox-cell' },
//         React.createElement(
//             'label',
//             { className: 'checkboxs' },
//             React.createElement(Input, {
//                 type: 'checkbox',
//                 checked: checked,
//                 className: 'checkbox_animated border border-primary',
//                 onChange: change,
//                 disabled: disabled
//             }),
//             // item.title
//         )
//     );
// }

// export default Checkbox;


